import { ReportingReceiptViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { Flex, Headings, Text } from '@foradevelopment/fora-ui';
import { FORA_SOURCE } from '@fora-monorepo/fora-common';

import { useTypedTranslation } from '../../../i18n/i18n';
import { ReportContainer } from '../ReportContainer';
import { ReportHeader } from '../ReportHeader';
import { PayMonthSummaryLine } from './PayMonthSummaryLine';
import { EmploymentSummaryLine } from './EmploymentSummaryLine';

export const ReportingReceiptModalContent = ({
  payMonthSummaries,
  reportDate,
  organizationName,
  organizationNumber,
  reporterName,
  source,
  employmentCount,
}: ReportingReceiptViewModel) => {
  const { t } = useTypedTranslation();
  const [date, time] = reportDate.split(' ');
  return (
    <Flex justifyContent="center">
      <ReportContainer>
        <ReportHeader
          reportType="reporting-receipt"
          reportDate={reportDate}
          organizationName={organizationName}
          organizationNumber={organizationNumber}
          payMonths={payMonthSummaries?.map(s => s.payMonth)}
        />
        <Headings.H4 marginTop={40}>{t('modal.reportReceipt.title')}</Headings.H4>
        <Text color="black70" fontWeight="light" marginBottom={16}>
          {t('modal.reportReceipt.reportDoneText', {
            date: reportDate ? date : '',
            time: reportDate ? time : '',
            employeeName: reporterName,
            reportSource:
              source === FORA_SOURCE
                ? t('modal.reportReceipt.reportDoneForaEService')
                : t('modal.reportReceipt.reportDoneFile'),
          })}
        </Text>
        {payMonthSummaries && payMonthSummaries.map((summary, i) => <PayMonthSummaryLine {...summary} key={i} />)}
        {!!employmentCount && <EmploymentSummaryLine employmentCount={employmentCount} />}
      </ReportContainer>
    </Flex>
  );
};
